import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';


const StateDef = {
    normal: {
        transitions: {
            measurePolygon: {
                target: 'measurePolygon',
            },
            selectRectangle: {
                target: 'selectRectangle',
            },
            selectPolygon: {
                target: 'selectPolygon',
            },
            deletePoint: {
                target: 'deletePoint',
            },
            drawBoundaryPolygon: {
                target: 'drawBoundaryPolygon',
            },
            drawBoundary: {
                target: 'drawBoundary',
            },
            cmaSubject: {
                target: 'cmaSubject',
            },
        },
    },
    selectRectangle: {
        transitions: {
            cancel: {
                target: 'normal',
            },
            complete: {
                target: 'normal',
            },
        },
    },
    selectPolygon: {
        transitions: {
            cancel: {
                target: 'normal',
            },
            complete: {
                target: 'normal',
            },
        },
    },
    deletePoint: {
        transitions: {
            deleteRectangle: {
                target: 'deleteRectangle',
            },
            deletePolygon: {
                target: 'deletePolygon',
            },
            done: {
                target: 'normal',
            },
            cancel: {
                target: 'normal',
            },
            clearAll: {
                target: 'normal',
            },
        },
    },
    deleteRectangle: {
        transitions: {
            cancel: {
                target: 'deletePoint',
            },
            complete: {
                target: 'deletePoint',
            },
        },
    },
    deletePolygon: {
        transitions: {
            cancel: {
                target: 'deletePoint',
            },
            complete: {
                target: 'deletePoint',
            },
        },
    },
    measure: {
        transitions: {
            measurePolygon: {
                target: 'measurePolygon',
            },
            clearMeasures: {
                target: 'normal',
            },
        },
    },
    measurePolygon: {
        transitions: {
            cancel: {
                target: 'normal',
            },
            complete: {
                target: 'measure',
            },
        },
    },
    drawBoundary: {
        transitions: {
            drawBoundaryPolygon: {
                target: 'drawBoundaryPolygon',
            },
            clearAreas: {
                target: 'drawBoundaryPolygon',
            },
            cancel: {
                target: 'normal',
            },
            complete: {
                target: 'normal',
            }
        },
    },
    drawBoundaryPolygon: {
        transitions: {
            cancel: {
                target: 'drawBoundary',
            },
            complete: {
                target: 'drawBoundary',
            },
        },
    },
    cmaSubject: {
        transitions: {
            position: {
                target: 'cmaSubjectPositioning',
            },
            normal: {
                target: 'normal',
            },
        },
    },
    cmaSubjectPositioning: {
        transitions: {
            save: {
                target: 'cmaSubject',
            },
            cancel: {
                target: 'cmaSubject',
            },
        },
    }
} as const;


export const MapToolsStore = signalStore(
    { providedIn: 'root' },

    withState<{ state: keyof typeof StateDef }>({
        state: 'normal',
    }),

    withMethods(store => ({
        transition(state: string) {
            const currentStateDef = StateDef[store.state()];
            // @ts-ignore
            const destination = currentStateDef.transitions[state];
            if (!destination) {
                return;
            }

            const target = destination.target;
            /*
            const targetDef = stateDef[target];

            destination.action?.();
            currentStateDef.actions?.onExit?.();
            targetDef.actions?.onEnter?.();
            console.log('new state', target);
            */
            patchState(store, { state: target });
        },
    })),

    withComputed(({ state }) => ({
        selectable: computed(() =>
            ['normal', 'measure'].includes(state())
        ),
        cancelable: computed(() =>
            ['selectRectangle', 'selectPolygon', 'deleteRectangle', 'deletePolygon', 'drawBoundaryPolygon'].includes(state())
        ),
        removing: computed(() =>
            ['deletePoint', 'deleteRectangle', 'deletePolygon'].includes(state())
        ),
    })),
);
